export default "__VITE_ASSET__C9yr2XJm__"